import { put, takeLatest } from 'redux-saga/effects';
import { GenPK } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction() {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/GenPK', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });       

        const product_key = yield response.text();

        // throw new Error("Sorry, but you are too young for this movie");
        yield put(GenPK.creators.genPKSuccess({ product_key }));

    } catch (e) {
        yield put(GenPK.creators.genPKFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GenPK.types.GEN_PK_REQUEST, runAction);
}